<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.phone"
        placeholder="手机号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="提现方式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="银行卡" :value="1" />
        <el-option label="支付宝" :value="2" />
      </el-select>

      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="待审核" :value="1" />
        <el-option label="审核成功" :value="5" />
        <el-option label="打款中" :value="4" />
        <el-option label="已打款" :value="2" />
        <el-option label="已驳回" :value="3" />
      </el-select>

      <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <span class="filter-item">
        <download-excel
          :fields="json_fields"
          :fetch="handleExport"
          type="xls"
          name="钱包提现信息.xls"
          worksheet="钱包提现信息"
        >
          <el-button type="success" :loading="exportLoading">
            导出提现信息
          </el-button>
        </download-excel>
      </span>
    </div>

    <div class="filter-container">
      <el-button
        class="filter-item"
        type="success"
        :disabled="selectdArr.length === 0"
        @click="cashOutManyPass"
        v-loading="passBtnLoading"
      >
        批量审核通过
      </el-button>
      <el-button
        class="filter-item"
        type="danger"
        :disabled="selectdArr.length === 0"
        @click="cashOutManyReject"
        v-loading="rejectBtnLoading"
      >
        批量驳回
      </el-button>
      <el-button
        class="filter-item"
        type="danger"
        :disabled="selectdArr.length === 0"
        @click="cashOutManySuccess"
        v-loading="rejectBtnLoading"
      >
        批量已打款
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :selectable="selected">
      </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="ID" width="95" v-if="false">
        <template slot-scope="scope">
          {{ scope.row.id }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.user ? scope.row.user.avatar : '#'"
            class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.account }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="真实姓名" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.snap ? JSON.parse(scope.row.snap).real_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="提现方式" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.snap && JSON.parse(scope.row.snap).type === 1"
            type="success"
          >
            银行卡</el-tag
          >
          <el-tag
            v-else-if="scope.row.snap && JSON.parse(scope.row.snap).type === 2"
            type="success"
            >支付宝</el-tag
          >
        </template>
      </el-table-column>

      <!--      <el-table-column label="身份证号码" min-width="80" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.user ? scope.row.payment_method.id_number : "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="身份证号码" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.snap ? JSON.parse(scope.row.snap).id_number : "-" }}
        </template>
      </el-table-column>

      <el-table-column label="银行卡号" min-width="80" align="center">
        <template slot-scope="scope">
          {{
            scope.row.snap ? JSON.parse(scope.row.snap).bank_card_number : "-"
          }}
        </template>
      </el-table-column>

      <el-table-column label="银行卡预留电话号码" min-width="80" align="center">
        <template slot-scope="scope">
          {{
            scope.row.snap ? JSON.parse(scope.row.snap).bank_card_phone : "-"
          }}
        </template>
      </el-table-column>

      <el-table-column label="支付宝账号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.snap ? JSON.parse(scope.row.snap).zfb_account : "-" }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="提现单号" min-width="80" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.cash_out_no }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <!--      <el-table-column label="付款单号" min-width="80" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.cash_out_trade_no }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="提现金额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>

      <el-table-column label="提现手续费" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.commission_money }}
        </template>
      </el-table-column>

      <el-table-column label="到账金额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.actual_money }}
        </template>
      </el-table-column>

      <el-table-column label="提现后钱包余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_balance }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="凭证" min-width="80" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.proof }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="审核时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.examine_at }}
        </template>
      </el-table-column>

      <el-table-column label="审核状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="warning"> 待审核</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="success"
            >已打款</el-tag
          >
          <el-tag v-else-if="scope.row.status === 3" type="danger"
            >已驳回</el-tag
          >
          <el-tag v-else-if="scope.row.status === 4" type="warning"
            >打款中</el-tag
          >
          <el-tag v-else-if="scope.row.status === 5" type="success"
            >审核成功</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="失败原因" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.fail_reason }}
        </template>
      </el-table-column>

      <el-table-column label="拒绝原因" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.refuse_reason }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

<!--      <el-table-column-->
<!--        label="操作"-->
<!--        width="150"-->
<!--        align="center"-->
<!--        class-name="fixed-height"-->
<!--        fixed="right"-->
<!--      >-->
<!--        <template slot-scope="scope">-->
<!--          <el-button-->
<!--            v-if="scope.row.status === 1"-->
<!--            size="mini"-->
<!--            type="success"-->
<!--            @click="payment(scope.row)"-->
<!--            >打款</el-button-->
<!--          >-->
<!--          <el-button-->
<!--            v-if="scope.row.status === 1"-->
<!--            size="mini"-->
<!--            type="danger"-->
<!--            @click="rejectPayment(scope.row)"-->
<!--            >驳回</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";
export default {
  components: { downloadExcel },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      passBtnLoading: false,
      rejectBtnLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: "",
        phone: "",
      },
      dialogFormVisible: false,
      btnLoading: false,
      exportLoading: false,
      form: {},
      dateArr: null,
      //导出
      json_fields: {
        手机号: {
          field: "user.account",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        昵称: "user.nickname",
        真实姓名: "payment_method.real_name",
        提现方式: {
          field: "pay_type",
          //自定义回调函数
          callback: (value) => {
            if (value == 2) {
              return "支付宝";
            } else if (value == 1) {
              return "银行卡";
            }
          },
        },
        身份证号码: {
          field: "payment_method.id_number",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        银行卡号: {
          field: "payment_method.bank_card_number",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        支付宝账号: {
          field: "payment_method.zfb_account",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        银行卡预留电话号码: {
          field: "payment_method.bank_card_phone",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        提现金额: {
          field: "money",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        提现手续费: {
          field: "commission_money",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        到账金额: {
          field: "actual_money",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        提现后钱包余额: {
          field: "after_balance",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        审核时间: {
          field: "examine_at",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        审核状态: {
          field: "status",
          //自定义回调函数
          callback: (value) => {
            if (value == 1) {
              return "待审核";
            } else if (value == 2) {
              return "已打款";
            } else if (value == 3) {
              return "已驳回";
            } else if (value == 4) {
              return "打款中";
            } else if (value == 5) {
              return "审核成功";
            }
          },
        },
        拒绝原因: "refuse_reason",
        创建时间: {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
      },
      selectdArr: [], // 多选框存放数据
    };
  },
  created() {
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    // handleExport() {
    //   this.exportLoading=true;
    //   var query =JSON.parse(JSON.stringify(this.listQuery))  ;
    //   query.limit = 99999999999999;
    //   return request({
    //     url: "/api/backend/consignment/walletList",
    //     method: "post",
    //     params: query,
    //   })
    //       .then((result) => {
    //         var json_data = result.data.data;
    //         this.header = "寄卖订单信息";
    //         return json_data;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         this.listLoading = false;
    //         this.exportLoading=false;
    //       });
    // },
    selected(row) {
      if (row.status === 1 || row.status === 5) {
        return true; //可勾选
      } else {
        return false; //不可勾选
      }
    },
    handleSelectionChange(val) {
      this.selectdArr = val.map((item) => {
        return item.id;
      });
    },
    cashOutManyPass() {
      this.passBtnLoading = true;
      this.$confirm("是否批量审核通过", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/consignment/cashOutManyPass",
            method: "post",
            data: {
              cash_out_ids: this.selectdArr,
            },
          })
            .then((result) => {
              // this.clearSelected();
              // 弹出消息框
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .finally(() => {
              this.passBtnLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
          this.passBtnLoading = false;
        });
    },
    cashOutManyReject() {
      this.rejectBtnLoading = true;
      // 弹出确认框
      // 弹出框填写拒绝原因
      return this.$prompt("请输入批量驳回原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputValidator(value) {
        //   if (value<=0) {
        //     return "请输入正确的排名人数";
        //   }
        // },
      })
        .then(({ value }) => {
          request({
            url: "/api/backend/consignment/cashOutManyReject",
            method: "post",
            data: {
              cash_out_ids: this.selectdArr,
              refuse_reason: value,
            },
          })
            .then((result) => {
              this.rejectBtnLoading = false;
              // this.clearSelected();
              // 弹出消息框
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .finally(() => {
              this.rejectBtnLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
          this.rejectBtnLoading = false;
        });
    },
    cashOutManySuccess() {
      this.passBtnLoading = true;
      this.$confirm("是否批量已打款(确保线下已给用户打款了)", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/consignment/cashOutManySuccess",
            method: "post",
            data: {
              cash_out_ids: this.selectdArr,
            },
          })
            .then((result) => {
              // this.clearSelected();
              // 弹出消息框
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .finally(() => {
              this.passBtnLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
          this.passBtnLoading = false;
        });
    },
    clearSelected() {
      this.$refs.orderTable.clearSelection();
    },
    handleExport() {
      this.exportLoading = true;
      var query = JSON.parse(JSON.stringify(this.listQuery));
      query.limit = 99999999999999;
      return request({
        url: "/api/backend/consignment/cashOutList",
        method: "post",
        params: query,
      })
        .then((result) => {
          var json_data = result.data.data;
          this.header = "钱包提现信息";
          return json_data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.listLoading = false;
          this.exportLoading = false;
        });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/consignment/cashOutList",
        method: "post",
        params: this.listQuery,
      }).then((response) => {
        console.log(response);
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    updateCashOutStatus(id, status, refuse_reason) {
      request({
        url: "/api/backend/consignment/cashOutStatus",
        method: "post",
        params: {
          cash_out_id: id,
          status: status,
          refuse_reason: refuse_reason,
        },
      }).then((response) => {
        console.log(response);
        if (response.code === 0) {
          // 弹出消息框
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getList();
        }
      });
    },
    payment(object) {
      // 弹出确认框
      this.$confirm("是否确认打款", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.updateCashOutStatus(object.id, 2, "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    rejectPayment(object) {
      // 弹出框填写拒绝原因
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator(value) {
          if (value === "" || value === null || value === undefined) {
            return "拒绝原因不能为空";
          }
        },
      })
        .then(({ value }) => {
          this.updateCashOutStatus(object.id, 3, value);
          // this.$message({
          //   type: 'success',
          //   message: '操作成功'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    // saveData() {
    //   this.btnLoading = true;
    //   request({
    //     url: "/api/backend/task/save",
    //     method: "post",
    //     data: this.form,
    //   })
    //     .then((response) => {
    //       this.btnLoading = false;
    //       this.dialogFormVisible = false;
    //       this.$notify({
    //         title: "成功",
    //         message: "保存成功",
    //         type: "success",
    //         duration: 2000,
    //       });
    //       this.getList();
    //     })
    //     .catch((err) => {
    //       this.btnLoading = false;
    //     });
    // },
  },
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>